<template>
    <div>
        <v-btn x-small @click="$emit('prev')" :disabled="!page || !totalPage || page <= 1 || totalPage == 0" class="c-btn-pagination">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-btn x-small @click="$emit('next')" :disabled="!page || !totalPage || totalPage == 0 || page >= totalPage" class="c-btn-pagination">
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
    </div>
</template>


<script>
export default {
  props:[
    "page",
    "totalPage"
  ]
}
</script>